import api from '../client'
import { clearAccessToken, setAccessToken } from '../authSession'

export const authApi = {
  login: async (email, password, totpCode, authFlowId) => {
    const payload = { email, password }
    if (totpCode) {
      payload.totp_code = totpCode
    }
    if (authFlowId) {
      payload.auth_flow_id = authFlowId
    }

    const response = await api.post('/auth/login', payload)
    if (response.data?.access_token) {
      setAccessToken(response.data.access_token)
    }
    return response.data
  },

  startMFAEnrollment: async (authFlowId) => {
    const response = await api.post('/auth/mfa/enroll', { auth_flow_id: authFlowId })
    return response.data
  },

  verifyMFAEnrollment: async (authFlowId, code) => {
    const response = await api.post('/auth/mfa/enroll/verify', { auth_flow_id: authFlowId, code })
    if (response.data?.access_token) {
      setAccessToken(response.data.access_token)
    }
    return response.data
  },
  
  refresh: async () => {
    const response = await api.post('/auth/refresh', undefined, {
      _skipAuthRefresh: true
    })
    if (response.data?.access_token) {
      setAccessToken(response.data.access_token)
    }
    return response.data
  },
  
  logout: async () => {
    try {
      await api.post('/auth/logout')
    } finally {
      clearAccessToken()
    }
  },
  
  getProfile: async () => {
    const response = await api.get('/auth/profile')
    return response.data
  },
  
  setupMFA: async (enable) => {
    const response = await api.post('/auth/mfa/setup', { enable })
    return response.data
  },
  
  verifyMFA: async (code) => {
    const response = await api.post('/auth/mfa/verify', { code })
    return response.data
  },
  
  updateProfile: async (updates) => {
    const response = await api.patch('/auth/profile', updates)
    return response.data
  },
  
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/auth/password', {
      current_password: currentPassword,
      new_password: newPassword
    })
    return response.data
  },

  forgotPassword: async (email) => {
    const response = await api.post('/auth/password/forgot', { email })
    return response.data
  },

  resetPassword: async (userId, code, newPassword) => {
    const response = await api.post('/auth/password/reset', {
      user_id: userId,
      code,
      new_password: newPassword
    })
    return response.data
  },

  acceptInvitation: async (userId, code, newPassword) => {
    const response = await api.post('/auth/invitations/accept', {
      user_id: userId,
      code,
      new_password: newPassword
    })
    return response.data
  },
  
  disableMFA: async (code) => {
    const response = await api.post('/auth/mfa/disable', { code })
    return response.data
  }
}
